// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sz-0";
export var checkoutRateBadgeLink = "_sz-1";